import React from "react";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import {
  OLD_UI_URL,
  REDIRECT_MVC,
} from "../services/api/api-client.js";
import '@progress/kendo-theme-default/dist/all.css';
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/globals.scss";

import { trackPromise } from "react-promise-tracker";
import qs from "qs";

import { connect } from "react-redux";
import {
  getCurrentUserToken,
  setCurrentUser,
} from "../redux/user/user-actions.js";
import { login } from "../redux/auth/auth-actions.js";
import { setSearchInput } from "../redux/search/search.actions.js";

import Login from "../components/Login/index.js";
import ForgotPassword from "../components/ForgotPassword/index.js";
import SetNewPassword from "../components/SetNewPassword/index.js";
import NavigationBar from "../components/navigation-bar/navigation-bar.jsx";

import TasksPage from "../pages/tasks/scenes/tasks-page/tasks-page.jsx";
import ProjectsPageNew from "../pages/projects/scenes/projects-page/projects-page.jsx";
import AdminPage from "../pages/admin/scenes/admin-page/admin-page.jsx";
import SettingsPage from "../pages/settings/scenes/settings-page/settings-page.jsx";
import ProfilePage from "../pages/profile/scenes/profile-page/profile-page.jsx";
import MissingPage from "../pages/errors/scenes/MissingPage/missing-page.jsx";
import ForbiddenPage from "../pages/errors/scenes/ForbiddenPage/forbidden-page.jsx";
import ServerPage from "../pages/errors/scenes/ServerErrorPage/server-page.jsx";
import SearchDetailedPage from "../pages/search-detailed/SearchDetailedPage.jsx";
import ErrorBoundary from "../components/error-pages/errorBoundary.jsx";
import NewDashboard from "../pages/new-dashboard/new-dashboard.jsx";
import { GetProfile } from "../services/api/profile-api.js";
import {
  LoginContext,
  GetCurrentUser,
} from "../services/api/authentication-api.js";
import { GetRolePrivilege } from "../services/api/role-privilege-api.js";
import { GetDepartment } from "../services/api/department-api.js";
import Onboarding from "../pages/Onboarding/index.js";
import GetStarted from "../components/GetStarted/GetStarted.jsx";
import { getUserSettings } from "../services/api/settings-api.js";
import NotificationPageNew from "../pages/notifications/notifications/notification-page/notification-page-new.jsx";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig, loginRequest } from "../authConfigAzureAd.js";
import { MsalProvider } from "@azure/msal-react";
import ExternalForm from "../pages/external-form/external-form.jsx";
import { getToken, setAuthCookie, removeAuthCookie } from "../services/api/api-util.js";
import { GetDefaultLandingPage, GetDefaultObjectLabels } from "../services/api/subdepartment-api.js";

const msalInstance = new PublicClientApplication(msalConfig);
const authType = window["APP_SETTINGS"].AUTH_TYPE;

class AppLegacy extends React.Component {
  state = {
    userID: -1,
    loggedIn: false,
    usingNewSite: window["APP_SETTINGS"].REACT_APP_USING_NEW_UI == "TRUE",
    showGetStarted: false,
    organizationName: "",
    currentUser: {},
    landingPage: "tasks",
  };

  authAzureAd = async () => {
    console.log("App.js Aquiring access token -->");
    await msalInstance.initialize();
    const accounts = await msalInstance.getAllAccounts();
    console.log("App.js accounts", accounts);
    if (accounts.length > 0) {
      console.log("App.js accounts.length > 0");
      const request = {
        ...loginRequest,
        account: accounts[0],
      };
      msalInstance
        .acquireTokenSilent(request)
        .then((response) => {
          console.log("App.js authAzureAd Access token -->");
          console.log(response);
          setAuthCookie(response.accessToken);
        })
        .catch((error) => {
          if (error.errorMessage.includes("interaction_required")) {
            msalInstance.acquireTokenRedirect(request);
          } else {
            console.log("App.js authAzureAd Access token error -->");
            console.error(error);
          }
        });
    }
  };

  componentDidMount = async () => {
    const { setCurrentUser, setSearchInput } = this.props;

    console.log("App.js componentDidMount");
    let token = getToken();
    if (authType === "AzureAD") {
      console.log("App.js Auth Type AzureAD");
      if (token) {
        console.log("App.js Cookie Value -->");
        const decodedToken = JSON.parse(atob(token.split(".")[1]));
        const currentTime = Date.now() / 1000;
        if (decodedToken.exp > currentTime) {
          console.log("App.js Token Not Expired -->");
          setAuthCookie(token);
        } else {
          console.log("App.js Token Expired -->");
          this.authAzureAd();
        }
      } else {
        console.log("App.js No Cookie Value calling authAzureAd -->");
        this.authAzureAd();
      }
    } else {
      if (!token) {
        this.setLoggedOut();
      } else {
        setAuthCookie(token);
      }
    }

    try {
      const profile = await GetProfile();

      let token = "";
      let Timezone = new Date().getTimezoneOffset();

      if (profile != null) {
        token = await getCurrentUserToken(profile.userName, profile.password);
        token = getToken();

        let userPassword = profile.password;
        if (profile.isSSO && !(userPassword?.length > 0)) {
          // Random password just to pass the LoginDto object validation that enforce the password to be at least 1 character long
          userPassword = "SBu2gr1Sqtne0iEHKcLdMp5YxiW5sxo0";
        }

        this.props.login({
          Username: profile.userName,
          Password: userPassword,
          Timezone: Timezone,
        });

        const department = await GetDepartment(profile.company);
        const privileges1 = await GetRolePrivilege(profile.role, token);
        const objectLabelsRes = await GetDefaultObjectLabels();
        let privileges = {};
        privileges1.forEach((privilege) => {
          privileges[privilege.MenuItem] = privilege;
        });

        const user = {
          profile,
          department,
          privileges,
          token,
          objectLabels: objectLabelsRes.data,
        };

        setCurrentUser(user);

        this.setState({
          organizationName: user.department?.name,
          currentUser: user,
        });
      } else {
        this.setLoggedOut();
      }
    } catch (error) {
      console.log(error);
    }

    trackPromise(
      GetCurrentUser().then(
        async (result) => {
          if (result > 0) {

            let landingPage = await GetDefaultLandingPage();
            if(landingPage.status === 200){
              this.setState({
                landingPage: landingPage.data,
                userID: result,
                loggedIn: true
              });
            }
            else{
              this.setState({
                userID: result,
                loggedIn: true
              });
            }
            let userSettings = await getUserSettings();
          } else {
            this.setState({
              loggedIn: false,
            });
          }
        },
        (error) => {
          console.log("API [GetCurrentUser] error: ");
          console.log(error);
          this.setState({
            userID: -1,
            loggedIn: false,
          });
        }
      ),
      "login-authentication"
    );
  };

  onShowGetStarted = () => this.setState({ showGetStarted: true });
  onHideGetStarted = () => this.setState({ showGetStarted: false });
  onHideOnboarding = () => this.onShowGetStarted();
  setLoggedIn = () => this.componentDidMount();

  setLoggedOut = () => {
    removeAuthCookie();

    this.setState({
      userID: -1,
      loggedIn: false,
      showGetStarted: false,
      organizationName: "",
    });

    if (REDIRECT_MVC === "TRUE") {
      window.location.href = OLD_UI_URL + "home/logout";
    } else {
      const locationPath = window.location.pathname;
      if (locationPath !== "/login" && !locationPath.includes("/external-form")) {
        window.location.href = "/login";
      }
    }
  };

  renderPage = (location) => {
    let routes = [
      {
        route: <Route path="/dashboard" />,
        path: "/dashboard",
        component: <NewDashboard />,
      },
      {
        route: <Route path="/projects" />,
        path: "/projects",
        component: <ProjectsPageNew />,
      },
      {
        route: <Route path="/tasks" />,
        path: "/tasks",
        component: <TasksPage />,
      },
      {
        route: <Route path="/admin" />,
        path: "/admin",
        component: <AdminPage />,
      },
      {
        route: <Route path="/settings" />,
        path: "/settings",
        component: <SettingsPage />,
      },
      {
        route: <Route path="/profile" />,
        path: "/profile",
        component: <ProfilePage />,
      },
      {
        route: <Route path="/notifications" />,
        path: "/notifications",
        component: <NotificationPageNew />,
      },
      {
        route: <Route path="/searchresults/:type" />,
        path: "/searchresults/:type",
        component: <SearchDetailedPage />,
      },
      {
        route: <Route path="/triyosoft-react-frontend" />,
        path: "/triyosoft-react-frontend",
        component: <Redirect to="/dashboard" />,
      },

      {
        route: <Route exact path="/" />,
        path: "/",
        component: <Redirect to={`/${this.state.landingPage}`} />,
      },

      {
        route: <Route path="/missing" />,
        path: "/missing",
        component: <MissingPage />,
      },
      {
        route: <Route path="/forbidden" />,
        path: "/forbidden",
        component: <ForbiddenPage />,
      },
      {
        route: <Route path="/internal-error" />,
        path: "/internal-error",
        component: <ServerPage />,
      },
      {
        route: <Route path="/external-form/:formId" />,
        path: "/external-form",
        component: <ExternalForm />,
      }
    ];

    const locationPath = location.location.pathname;
    const qsParams = qs.parse(location.location.search, {
      ignoreQueryPrefix: true,
    });
    const { page, ...restOfQsParams } = qsParams;

    if (locationPath === "/index.html" && page === "tasks")
      return <Redirect to="/tasks" />;
    if (locationPath === "/index.html" && page === "admin")
      return <Redirect to="/admin" />;
    if (locationPath === "/index.html" && page === "projects")
      return <Redirect to="/projects" />;
    if (locationPath === "/index.html" && page === "dashboard")
      return <Redirect to="/dashboard" />;
    if (this.state.loggedIn &&  locationPath === "/index.html" && page === "default")
      return <Redirect to={`/${this.state.landingPage}`} />;

    if (locationPath === "/index.html" && page === "missing") {
      return (
        <div>
          <NavigationBar key={this.state.userID} onLogout={this.setLoggedOut} />
          <MissingPage />
        </div>
      );
    }

    if (locationPath === "/index.html" && page === "external-form"){
      return <Redirect to="/external-form" />;
    }

    if (locationPath === "/login" && page === "login")
      return <ServerPage detail="Backend Server is not Working" />;

    if (
      locationPath === "/registrations" ||
      (locationPath === "/index.html" && page === "registrations")
    ) {
      return this.state.loggedIn ? (
        <Redirect to="/tasks" />
      ) : (
        <Onboarding onLogin={this.setLoggedIn} onHide={this.onHideOnboarding} />
      );
    }

    if (this.state.loggedIn) {
      return (
        <React.Fragment>
          <GetStarted
            show={this.state.showGetStarted}
            onHide={this.onHideGetStarted}
            organizationName={this.state.organizationName}
          />
          <NavigationBar key={this.state.userID} onLogout={this.setLoggedOut} />
          <div className="navbar-margin">
          <ErrorBoundary>
            <TransitionGroup>
              <CSSTransition
                key={locationPath}
                appear={true}
                timeout={300}
                classNames="section"
              >
                <Switch location={location.location}>
                  {routes.map((route) => (
                    <route.route.type {...route.route.props} key={route.path}>
                      {() => {
                        return <div className="section">{route.component}</div>;
                      }}
                    </route.route.type>
                  ))}
                </Switch>
              </CSSTransition>
            </TransitionGroup>
          </ErrorBoundary>
          </div>
        </React.Fragment>
      );
    }
    // not logged in
    else {
      return (
        <React.Fragment>
          <Switch key={"switch"}>
            <Route path="/external-form/:formId">
              <ExternalForm/>
            </Route>,
            <Route exact={true} path="/">
              <Login
                onLogin={this.setLoggedIn}
                onLogout={this.setLoggedOut}
                setCurrentUser={setCurrentUser}
              ></Login>
            </Route>
            ,
            <Route exact={true} path="/login">
              <Login
                onLogin={this.setLoggedIn}
                onLogout={this.setLoggedOut}
                setCurrentUser={setCurrentUser}
              ></Login>
            </Route>
            ,
            <Route path="/forgot-password">
              <ForgotPassword />
            </Route>
            ,
            <Route path="/reset-password">
              <SetNewPassword />
            </Route>

          </Switch>
        </React.Fragment>
      );
    }
  };

  render = () => {
    return (
      <MsalProvider instance={msalInstance}>
        <LoginContext.Provider
          value={{
            hostURL: this.state.hostURL,
            userID: this.state.userID,
            loggedIn: this.state.loggedIn,
            usingNewSite: this.state.usingNewSite,
            currentUser: this.state.currentUser,
          }}
        >
          <div className="App">

            <Router>
              <Route
                render={(location) => {
                  return this.renderPage(location);
                }}
              ></Route>
            </Router>
          </div>
        </LoginContext.Provider>
      </MsalProvider>
    );
  };
}

const mapDispatch = (dispatch) => ({
  setCurrentUser: (user) => dispatch(setCurrentUser(user)),
  login: (userCredentials) => dispatch(login(userCredentials)),
  setSearchInput: (searchInput) => dispatch(setSearchInput(searchInput)),
});

export default connect(null, mapDispatch)(AppLegacy);